module.exports = __webpack_public_path__ + "img/icon-success.f03c4997.svg";